module.exports = __webpack_public_path__ + "assets/webgl/LM_1_0.bb4fd70b.jpg";